import React from "react";
import AlertComponent from "./AlertComponent";
import Stack from "react-bootstrap/Stack";

function BrowserComponent() {
  return (
    <div className="container">
      <div className="top-div">
        <h1 className="web-h1">Install Carplayhacks App</h1>
        <br />
        <p className="web-para">
          You can install all the carplayhacks apps including{" "}
          <span className="bold-text">WheelPal App</span> and{" "}
          <span className="bold-text">InCar app</span> through the carplayhacks
          app.
        </p>
        <br />
        <p className="web-para">
          The installation process needs to happen in the Safari browser.
          <span className="bold-text">Scan the below QR code.</span> You will be
          redirected to Safari automatically.
        </p>
      </div>
      <div className="container qr-section">
        <img
          src="https://carplayhacks.com/apps/images/qrcode_carplayhacks_app_addtohome.png"
          alt="Scan QR Code"
          width="270px"
          className="center"
        />
        <div className="row">
          <div className="col-sm-4"></div>
          <div className="col-sm-4"></div>
          <div className="col-sm-4"></div>
        </div>
      </div>
    </div>
  );
}

export default BrowserComponent;
